<template>
  <div class="main">
    <div class="box">
      <p class="title">
        长按识别二维码<br>
        领取开店学习资料
      </p>
      <div class="img-box">
        <img src="../../assets/images/yaoqing/code.jpeg" width="100%" alt="">
      </div>
      <p class="line"></p>
      <p class="tips">如有咨询问题，可点击【专家咨询】</p>
    </div>
    <div class="button">长按识别 关注后领取</div>
  </div>
</template>
<script>
  export default {
    name: 'ResultInvite',
    data () {
      return {}
    }
  }
</script>
<style lang="scss" scoped>
  @import "../../assets/scss/base/_mixin";
  .main {
    overflow: auto;
    width: 100%;
    background: #fff;
  }
  .box {
    overflow: hidden;
    width: px2rem(639px);
    height: px2rem(880px);
    margin: px2rem(90px) auto 0 auto;
    background: url("../../assets/images/yaoqing/result-bg.png") no-repeat;
    background-size: cover;
  }
  .title {
    width: px2rem(239px);
    text-align: center;
    color: #666666;
    margin: px2rem(77px) auto px2rem(51px) auto;
  }
  .img-box {
    width: px2rem(375px);
    height: px2rem(375px);
    margin: 0 auto;
  }
  .line {
    margin: px2rem(99px) auto 0 auto;
    width: px2rem(523px);
    height: px2rem(1px);
    border-top: 1px dashed #888;
  }
  .tips {
    margin-top: px2rem(87px);
    color: #666;
    font-size: px2rem(28px);
    text-align: center;
  }
  .button {
    margin: px2rem(28px) auto;
    width: px2rem(614px);
    height: px2rem(97px);
    line-height: px2rem(97px);
    text-align: center;
    border-radius: px2rem(50px);
    font-size: px2rem(36px);
    color: #fff;
    background: #fc551f;
  }
</style>



// WEBPACK FOOTER //
// result.vue?6b4bd6fa